export enum RedirectURLError {
  GDPRConsentRequired = 'GDPR consent required',
  OnlyAllowedForNonSignableDocuments = 'Only allowed for non-signable documents',
  EmailValidationFailed = 'Email validation failed',
  FailedToSaveGDPRConsent = 'Failed to save GDPR consent',
}
